import get from 'lodash/get';
import { MultiSelectFilter } from '@glu/grid-react';
import formatters, { getValueOrDefault } from '../../../basicGrid/helpers/formatters';
import { dateFilterParams } from '../../../basicGrid/utils';

// api
import { deleteWireImportMap, deleteACHImportMap } from '../../../../api/wireImports/service';
import { PROCESS_MODES_NAMES } from '../utils';

const deleteImportMap = (data) => {
  return data.type === 'ACH'
    ? deleteACHImportMap({ mapCode: get(data, 'mapCode') })
    : deleteWireImportMap({ mapId: get(data, 'mtMapId') });
};

const viewImportMap = ({ baseURL, data, history, location }) => {
  if (data.type === 'ACH') {
    return history.push({
      pathname: `${baseURL}/view/ach/${data.mapCode}`,
      state: { previous: location.pathname }
    });
  }

  return history.push({
    pathname: `${baseURL}/view/wires/${data.mtMapId}`,
    state: { paymentType: data.type, previous: location.pathname }
  });
};

const valueGetter = (locale) => getValueOrDefault(locale, locale['common.grid.empty']);

export const handleImportMapActions = (
  action,
  { baseURL, data, history, locale, location, updates }
) => {
  switch (action) {
    case 'view':
      viewImportMap({ data, history, location, baseURL });
      break;
    case 'delete':
      // pass id payload to delete service
      deleteImportMap(data).subscribe(({ success }) => {
        // use response to populate mess
        if (!success) {
          updates.setMessages([
            {
              id: 1,
              title: locale['payments.manageImportMaps.delete.failed'],
              data: { mapName: data.mapName },
              success: false
            }
          ]);
        } else {
          updates.setMessages([
            {
              id: 1,
              title: locale['payments.manageImportMaps.delete.succeeded'],
              data: { mapName: data.mapName },
              success: true
            }
          ]);
        }
      });
      break;
    case 'modify':
      history.push({
        pathname: `${baseURL}/modify/${data.type === 'ACH' ? 'ach' : 'wires'}/${
          data.type === 'ACH' ? data.mapCode : data.mtMapId
        }`,
        state: { paymentType: data.type, createdBy: data.createdBy, previous: location.pathname }
      });
      break;
    default:
  }
};

export const columns = ({ locale, showDeleteModalFunc, ...props }) => [
  {
    headerName: locale['common.actions'],
    field: 'possibleActions',
    cellRenderer: 'actions',
    filterable: false,
    sortable: false,
    actions: [
      {
        label: locale['common.view'],
        condition: ({ data }) => data?.possibleActions?.includes('View'),
        handler: ({ data }) => {
          handleImportMapActions('view', { locale, data, ...props });
        }
      },
      {
        label: locale['common.modify'],
        condition: ({ data }) => data?.possibleActions?.includes('Modify'),
        handler: ({ data }) => handleImportMapActions('modify', { locale, data, ...props })
      },
      {
        label: locale['common.delete'],
        condition: ({ data }) =>
          data?.possibleActions?.includes('Delete') && data?.templateType === 'Custom',
        handler: (data) => showDeleteModalFunc({ locale, data: data?.data, ...props })
      }
    ]
  },
  {
    headerName: locale['payments.manageImportMaps.mapName'],
    field: 'mapName',
    valueGetter: valueGetter(locale)
  },
  {
    headerName: locale['payments.manageImportMaps.paymentType'],
    field: 'type',
    valueGetter: valueGetter(locale)
  },
  {
    headerName: locale['wireImports.mapFormat'],
    field: 'mapType',
    valueGetter: valueGetter(locale)
  },
  {
    headerName: locale['payments.manageImportMaps.mapType'],
    field: 'processMode',
    options: [
      {
        name: locale['wireImports.ADD_ONLY'],
        value: PROCESS_MODES_NAMES.ADD_ONLY
      },
      {
        name: locale['wireImports.ADD_AND_UPDATE'],
        value: PROCESS_MODES_NAMES.ADD_AND_UPDATE
      },
      {
        name: locale['wireImports.UPDATE_ONLY'],
        value: PROCESS_MODES_NAMES.UPDATE_ONLY
      }
    ],
    filter: MultiSelectFilter,
    type: 'multiselect',
    valueFormatter: /* istanbul ignore next */ ({ value }) =>
      value ? locale[`wireImports.${value.toUpperCase()}`] : ''
  },
  {
    headerName: locale['payments.manageImportMaps.createdBy'],
    field: 'createdBy',
    valueGetter: valueGetter(locale)
  },
  {
    field: 'lastUsedDate',
    valueFormatter: formatters.toDate({ locale, name: 'lastUsedDate' }),
    valueGetter: valueGetter(locale),
    headerName: locale['payments.manageImportMaps.lastUsedDate'],
    type: 'date',
    filter: 'agDateColumnFilter',
    filterParams: dateFilterParams,
    filterValueGetter: formatters.toDate({ locale, name: 'lastUsedDate' })
  },
  {
    headerName: locale['payments.manageImportMaps.lastUsedBy'],
    field: 'lastUsedBy',
    valueGetter: valueGetter(locale)
  }
];
